module.exports = __webpack_public_path__ + "img/Phone (1).f6cbb852.svg";